import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer bg--pink width--full" }
const _hoisted_2 = { class: "footer-content height--full width--page-size margin--auto display--flex justify--space-between flex--wrap-mobile text--center-mobile" }
const _hoisted_3 = { class: "footer-links display--flex justify--space-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "footer-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainCube = _resolveComponent("MainCube")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"footer-header\" data-v-3f8cc374><h3 class=\"footer-logo text--white\" data-v-3f8cc374> SnapShare </h3><h4 data-v-3f8cc374> האלבום שלך באירוע הקרוב </h4><div class=\"social-media display--flex justify--center-mobile\" data-v-3f8cc374><a href=\"https://www.facebook.com/share/1By1U5frDi/?mibextid=wwXIfr\" target=\"_blank\" data-v-3f8cc374><img loading=\"lazy\" src=\"/assets/icons/facebook-icon.webp\" alt=\"facebook\" data-v-3f8cc374></a><a href=\"https://www.instagram.com/snapshare_live?igsh=MXpudTBjMWhxeWw%3D&amp;utm_source=qr\" target=\"_blank\" data-v-3f8cc374><img loading=\"lazy\" src=\"/assets/icons/instagram-icon.webp\" alt=\"instagram\" data-v-3f8cc374></a></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: "/#features" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("p", null, "מה מקבלים", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/#how-it-works" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("p", null, "איך זה עובד", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/#how-it-looks" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("p", null, "איך זה נראה", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/#pricing" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("p", null, "המסלולים שלנו", -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: "/contact" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("p", null, "צור קשר", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/order" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("p", null, "הזמנה", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/terms-and-conditions" }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("p", null, "תנאי האתר", -1)
            ])),
            _: 1
          })
        ]),
        (!_ctx.isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: "/login" }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("p", null, "התחבר", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/signup" }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("p", null, "הרשמה", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/forgot-password" }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("p", null, "שכחתי סיסמה", -1)
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLoggedIn || _ctx.hasActiveEvent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/profile"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("p", null, "פרופיל", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasActiveEvent)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/event"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createElementVNode("p", null, "אירוע", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_MainCube, {
      left: "20%",
      top: "-10%",
      width: "xxx-large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "10%",
      top: "-5%",
      width: "large",
      height: "xx-large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "30%",
      top: "-19%",
      width: "large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "0%",
      top: "29%",
      width: "small",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      right: "0%",
      top: "27%",
      width: "x-large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "50%",
      top: "39%",
      width: "xxx-large",
      height: "medium"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "45%",
      bottom: "5%",
      width: "x-large",
      height: "xxx-large"
    }),
    _createElementVNode("p", _hoisted_6, " © " + _toDisplayString(_ctx.currentYear) + " SnapShare ", 1)
  ]))
}